<template>
  <div>
    <!-- メニューヘッダー -->
    <TheSheetMenuHeader />

    <!-- メニュー一覧 -->
    <TheSheetMenuIndex
      :menus="props.menus"
      :radio="radio"
      @grandParent="changedRadioParent"
    />

    <!-- ボトムの"引き換える"ボタン -->
    <TheSheetMenuBottom :radio="radio" />
  </div>
</template>

<script>
// Vue
import { onMounted, computed, watchEffect, ref, props } from "vue";
import { useStore } from "vuex";

export default {
  name: "TemplateSheetMenu",
  props: {
    menus: {
      type: Array,
      required: false,
    },
  },
  setup(props) {
    const radio = ref(null);

    const store = useStore();

    const changedRadioParent = (value) => {
      radio.value = value;
    };

    const masterSheet = computed(() => store.getters["ticketing/masterSheet"]);

    return {
      masterSheet,
      radio,
      props,
      changedRadioParent,
    };
  },
};
</script>
